export default "__VITE_ASSET__DhhoUR5H__"